export const PREFIX = 'blue-theme'
export const DOT_PREFIX = `.${PREFIX}`
